import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ASSETS_QUERY_KEY} from "../queryKeys";

type DeleteAssetVariables = {id: number};

const deleteAsset = async ({id}: DeleteAssetVariables): Promise<boolean> => {
  const response = await axiosReachInstance.delete<boolean, AxiosResponse<boolean>>(`/assets/${id}`);
  return response.data;
};

export const useDeleteAsset = (
  options?: BaseMutationOptions<boolean, DeleteAssetVariables>
): BaseUseMutationResult<boolean, DeleteAssetVariables> => {
  return useBaseMutation<boolean, DeleteAssetVariables>(deleteAsset, {
    ...options,
    prefixKeysToInvalidate: () => [[ASSETS_QUERY_KEY]],
  });
};
